import type { Component, JSX } from "solid-js";
import ManeuverSettings from "./ManeuverSettings";

/** Fleet Summary Tables page settings — history filters via ManeuverSettings (no race/leg/tack/video). */
export interface SummaryTablesSettingsProps {
  useIconTrigger?: boolean;
  dataSourcesOptions?: Array<{
    key?: string;
    label?: string;
    name?: string;
    signal?: [() => boolean, (value: boolean) => void];
  }>;
  gradeOptions?: number[];
  stateOptions?: string[];
  selectedGrades?: number[] | (() => number[]);
  selectedStates?: string[] | (() => string[]);
  selectedTrainingRacing?: "TRAINING" | "RACING" | null | (() => "TRAINING" | "RACING" | null);
  onTrainingRacingFilterChange?: (type: "TRAINING" | "RACING" | null) => void;
  setGradeOptions?: (options: number[]) => void;
  setStateOptions?: (options: string[]) => void;
  toggleGradeFilter?: (grade: number) => void;
  toggleStateFilter?: (state: string) => void;
  filterYear?: string | (() => string);
  filterEvent?: string | (() => string);
  filterConfig?: string | (() => string);
  filterState?: string | (() => string);
  onFilterYearChange?: (year: string) => void;
  onFilterEventChange?: (event: string) => void;
  onFilterConfigChange?: (config: string) => void;
  onFilterStateChange?: (state: string) => void;
  onApplyFilters?: () => void;
  showTimeline?: () => boolean;
  onTimelineChange?: (value: boolean) => void;
  /** Hide date range, year, event, and config filters (e.g. live pages scoped to today). */
  hideProjectScopeFilters?: boolean;
  /** Pivot the summary tables (metrics as rows, sources as columns). Toggle shown only when the handler is supplied. */
  pivotTables?: () => boolean;
  onPivotTablesChange?: (value: boolean) => void;
  /** Modal header text. Default "Summary Settings". */
  modalTitle?: string;
  /** Page-specific controls appended to the Display Options row. */
  extraDisplayOptions?: JSX.Element;
}

const SummaryTablesSettings: Component<SummaryTablesSettingsProps> = (props) => {
  return (
    <ManeuverSettings
      useIconTrigger={props.useIconTrigger ?? true}
      isHistoryPage={true}
      dataSourcesOptions={props.dataSourcesOptions}
      gradeOptions={props.gradeOptions}
      stateOptions={props.stateOptions}
      selectedGrades={props.selectedGrades}
      selectedStates={props.selectedStates}
      selectedTrainingRacing={props.selectedTrainingRacing}
      onTrainingRacingFilterChange={props.onTrainingRacingFilterChange}
      setGradeOptions={props.setGradeOptions}
      setStateOptions={props.setStateOptions}
      toggleGradeFilter={props.toggleGradeFilter}
      toggleStateFilter={props.toggleStateFilter}
      filterYear={props.filterYear}
      filterEvent={props.filterEvent}
      filterConfig={props.filterConfig}
      filterState={props.filterState}
      onFilterYearChange={props.onFilterYearChange}
      onFilterEventChange={props.onFilterEventChange}
      onFilterConfigChange={props.onFilterConfigChange}
      onFilterStateChange={props.onFilterStateChange}
      onApplyFilters={props.onApplyFilters}
      showTimeline={props.showTimeline}
      onTimelineChange={props.onTimelineChange}
      hideProjectScopeFilters={props.hideProjectScopeFilters}
      modalTitle={props.modalTitle ?? "Summary Settings"}
      pivotTables={props.pivotTables}
      onPivotTablesChange={props.onPivotTablesChange}
      extraDisplayOptions={props.extraDisplayOptions}
      includeAllGradeOption={true}
      hideDisplayOptions={false}
      showEditManeuverOverlayButton={false}
      componentConfig={{
        showGrades: true,
        showRaces: false,
        showLegs: false,
        showStates: true,
      }}
    />
  );
};

export default SummaryTablesSettings;
